import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { FiLogOut, FiUser } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import logoImage from '../assets/images/logo-2.jpg';

const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background-color: #0a0a2e;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  position: relative;
  color: white;
`;

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
`;

const LogoIcon = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
  }
`;

const LogoText = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: white;
`;

const NavLinks = styled.nav`
  display: flex;
  gap: 24px;
`;

const NavLink = styled(Link)`
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  text-decoration: none;
  position: relative;
  padding: 5px 0;
  transition: all 0.3s ease;
  
  &:hover {
    color: white;
  }
  
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: 0;
    left: 0;
    background: linear-gradient(90deg, #0000fe, #6060ff);
    transition: width 0.3s ease;
  }
  
  &:hover:after {
    width: 100%;
  }
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
`;

const LogoutButton = styled.button`
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  border: none;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  
  &:hover {
    color: white;
  }
`;

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <HeaderContainer>
      <Logo to="/">
        <LogoIcon src={logoImage} alt="Blockchain AI Data Layer Logo" />
        <LogoText>Chain3 AI</LogoText>
      </Logo>
      
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <NavLinks>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/chat">Chat</NavLink>
          <NavLink to="#">Documentation</NavLink>
        </NavLinks>
        
        {user && (
          <UserSection>
            <UserInfo>
              <FiUser />
              <span>{user.email}</span>
            </UserInfo>
            <LogoutButton onClick={handleLogout}>
              <FiLogOut />
              <span>Logout</span>
            </LogoutButton>
          </UserSection>
        )}
      </div>
    </HeaderContainer>
  );
}

export default Header;
